/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Has_TerraceInputs */

const cs_form_has_terrace = /** @type {(inputs: Form_Has_TerraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terasa`)
};

const en_form_has_terrace = /** @type {(inputs: Form_Has_TerraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terrace`)
};

/**
* | output |
* | --- |
* | "Terrace" |
*
* @param {Form_Has_TerraceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_has_terrace = /** @type {((inputs?: Form_Has_TerraceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Has_TerraceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_has_terrace(inputs)
	return cs_form_has_terrace(inputs)
});